import { DeleteResponse, TextResponse, TextPageResponse, TextSimplePageResponse, TextWithTextBlockResponse, TextListResponse, TextManualOrderListResponse, TextWithTextBlockAndRelatedProjectResponse } from '../dto/ResDtoRepository';
import { MetadataForQuery, CreateTextReq, DeleteTextReq, UpdateTextReq, UpdateTextBulkReq, UpdateReorderListReq } from '../dto/ReqDtoRepository';
import { TextFilterData, TextSortData } from '../dto/EntityRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';
import { buildTextListParams } from '../util/textListParams';


export const getText = async (textId: string): Promise<TextWithTextBlockAndRelatedProjectResponse> => {
  return sendGetApiRequest<TextWithTextBlockAndRelatedProjectResponse>(`/api/v1/text?textId=${textId}`);
};

export const getTextForOwner = async (aui: string, textId: string): Promise<TextWithTextBlockAndRelatedProjectResponse> => {
  return sendApiRequest<TextWithTextBlockAndRelatedProjectResponse>('get', `/api/v1/text/owner?aui=${aui}&textId=${textId}`);
};

export const getTextList = async (aui: string, metaData: MetadataForQuery): Promise<TextPageResponse> => {
  const params = buildTextListParams(aui, {
    page: metaData.page,
    size: metaData.size,
    sortData: metaData.sortData as TextSortData,
  }, metaData.filterData as TextFilterData | {});
  return sendGetApiRequest<TextPageResponse>(`/api/v1/text/list?${params.toString()}`);
};

export const getTextListForOwner = async (aui: string, metaData: MetadataForQuery): Promise<TextPageResponse> => {
  const params = buildTextListParams(aui, {
    page: metaData.page,
    size: metaData.size,
    sortData: metaData.sortData as TextSortData,
  }, metaData.filterData as TextFilterData | {});
  return sendApiRequest<TextPageResponse>('get', `/api/v1/text/list/owner?${params.toString()}`);
};

/** 소유자: 수동 순서가 있는 텍스트만 (서버에서 lex index 오름차순) */
export const getManualOrderTextListForOwner = async (aui: string): Promise<TextManualOrderListResponse> => {
  const params = new URLSearchParams({ aui });
  return sendApiRequest<TextManualOrderListResponse>('get', `/api/v1/text/list/manual-order/owner?${params.toString()}`);
};

/** 소유자: PE Import Text 목록. public GET이 아님. */
export const getSimpleTextListForOwner = async (aui: string, metaData: MetadataForQuery): Promise<TextSimplePageResponse> => {
  const sortData = metaData.sortData as TextSortData;
  return sendApiRequest<TextSimplePageResponse>(
    'get',
    `/api/v1/text/list/simple/owner?aui=${aui}&page=${metaData.page}&size=${metaData.size}&sortBy=${sortData.sort}&direction=${sortData.direction}`,
  );
};

export const createText = async (aui: string, data: CreateTextReq): Promise<TextWithTextBlockResponse> => {
  return sendApiRequest<TextWithTextBlockResponse>('post', `/api/v1/text?aui=${aui}`, data);
};

export const updateText = async (aui: string, data: UpdateTextReq): Promise<TextWithTextBlockResponse> => {
  return sendApiRequest<TextWithTextBlockResponse>('put', `/api/v1/text?aui=${aui}`, data);
};

export const updateTextBulk = async (aui: string, data: UpdateTextBulkReq): Promise<TextListResponse> => {
  return sendApiRequest<TextListResponse>('put', `/api/v1/text/bulk?aui=${aui}`, data);
};

export const reorderTexts = async (aui: string, data: UpdateReorderListReq): Promise<TextListResponse> => {
  return sendApiRequest<TextListResponse>('put', `/api/v1/text/reorder?aui=${aui}`, data);
};

export const toggleTextAccess = async (aui: string, data: UpdateTextReq): Promise<TextResponse> => {
  return sendApiRequest<TextResponse>('put', `/api/v1/text/toggle-access?aui=${aui}`, data);
};

export const deleteText = async (aui: string, data: DeleteTextReq): Promise<DeleteResponse> => {
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/text?aui=${aui}&textId=${data.textId}`);
};

export const deleteTextsBulk = async (aui: string, data: string[]): Promise<DeleteResponse> => {
  const params = new URLSearchParams({ aui, textIds: data.join(',') });
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/text/bulk?${params.toString()}`);
};